const searchToken = (id) => (
  `
  token(id: "${id}"){
    id
    siteId
    endDate
    entityId
  }
  `
);

export default searchToken;
